import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import api from '../services/api';
import SliderSection from '../components/homepage/SliderSection';
import WelcomeSection from '../components/homepage/WelcomeSection';
import NewsSection from '../components/homepage/NewsSection';
import NoticesSection from '../components/homepage/NoticesSection';
import ServicesSection from '../components/homepage/ServicesSection';
import StatisticsSection from '../components/homepage/StatisticsSection';
import DepartmentsSection from '../components/homepage/DepartmentsSection';
import GallerySection from '../components/homepage/GallerySection';
import AnnouncementSection from '../components/homepage/AnnouncementSection';
import OfficerSection from '../components/homepage/OfficerSection';
import WardCouncillorSection from '../components/homepage/WardCouncillorSection';
import EmployeeListSection from '../components/homepage/EmployeeListSection';
import LeaderSection from '../components/homepage/LeaderSection';
import ProjectMarquee from '../components/homepage/ProjectMarquee';
import './Home.css';

const Home = () => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadHomepageSections();
  }, []);

  const loadHomepageSections = async () => {
    try {
      const response = await api.get('/homepage-sections/');
      setSections(response.data);
    } catch (error) {
      console.error('Error loading homepage sections:', error);
    } finally {
      setLoading(false);
    }
  };

  const renderSection = (section) => {
    switch (section.section_type) {
      // case 'slider':
      //   return <SliderSection key={section.id} section={section} layout={section.layout_variant} />;
      case 'slider':
        return (
          <React.Fragment key={section.id}>
            <div className="slider-with-leader-wrapper">
              <SliderSection section={section} />
              <LeaderSection />
            </div>
          </React.Fragment>
        );

      case 'welcome':
        return <WelcomeSection key={section.id} section={section} layout={section.layout_variant} />;
      case 'news':
        return <NewsSection key={section.id} section={section} layout={section.layout_variant} />;
      case 'notices':
        return <NoticesSection key={section.id} section={section} layout={section.layout_variant} />;
      case 'services':
        return <ServicesSection key={section.id} section={section} layout={section.layout_variant} />;
      case 'statistics':
        return <StatisticsSection key={section.id} section={section} layout={section.layout_variant} />;
      case 'departments':
        return <DepartmentsSection key={section.id} section={section} layout={section.layout_variant} />;
      case 'gallery':
        return <GallerySection key={section.id} section={section} layout={section.layout_variant} />;
      case 'announcements':
        return <AnnouncementSection key={section.id} section={section} layout={section.layout_variant} />;
      case 'officers':
        return <OfficerSection key={section.id} section={section} layout={section.layout_variant} />;
      case 'ward_councillors':
        return <WardCouncillorSection key={section.id} section={section} layout={section.layout_variant} />;
      case 'employees':
        return <EmployeeListSection key={section.id} section={section} layout={section.layout_variant} />;
      case 'projects':
        return <ProjectMarquee section={section} />;
      case 'custom_html':
        return (
          <section key={section.id} className={`homepage-section ${section.css_class}`}>
            <Container>
              <div dangerouslySetInnerHTML={{ __html: section.content }} />
            </Container>
          </section>
        );
      default:
        return null;
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }


  const groupSections = (sections) => {
    const groups = [];
    let i = 0;
    while (i < sections.length) {
      if (sections[i].column_span === 2) {
        // Collect all consecutive half-width sections
        const halfGroup = [];
        while (i < sections.length && sections[i].column_span === 2) {
          halfGroup.push(sections[i]);
          i++;
        }
        // Push them as pairs into groups
        for (let j = 0; j < halfGroup.length; j += 2) {
          groups.push({
            type: 'half-row',
            items: halfGroup.slice(j, j + 2), // pair of 2 (or 1 if odd leftover)
          });
        }
      } else {
        groups.push({ type: 'full', item: sections[i] });
        i++;
      }
    }
    return groups;
  };

  // Add a helper to check if section has a valid renderer
  const isRenderableSection = (section) => {
    const renderableSectionTypes = [
      'slider', 'welcome', 'news', 'notices', 'services',
      'statistics', 'departments', 'gallery', 'announcements',
      'officers', 'ward_councillors', 'employees', 'custom_html',
      'projects'
    ];
    return renderableSectionTypes.includes(section.section_type);
  };

  // Then filter BEFORE grouping:
  const grouped = groupSections(
    sections
      .filter(s => s.is_active)
      .filter(s => isRenderableSection(s))  // ← ADD THIS
  );

  return (
    <div className="homepage">
      {grouped.map((group, idx) => {
        if (group.type === 'full') {
          // ✅ NO extra wrapper — renderSection already returns a <section> tag
          return (
            <React.Fragment key={group.item.id}>
              {renderSection(group.item)}
            </React.Fragment>
          );
        }

        // half-row: side by side
        return (
          <div key={`half-row-${idx}`} className="section-row">
            <Container fluid className="p-0">
              <Row className="g-0 m-0">
                {group.items.map(section => (
                  <Col md={6} key={section.id} className="section-col p-0">
                    {/* ✅ NO extra homepage-section wrapper here either */}
                    {renderSection(section)}
                  </Col>
                ))}
              </Row>
            </Container>
          </div>
        );
      })}
    </div>
  );

};

export default Home;
